<template>
  <pt-link-manage class="pt-link-manage__withData" ref="table" @deleteLink="deleteLink"></pt-link-manage>
</template>

<script>
import PtLinkManage from './index'
export default {
  name: 'pt-link-manage__withData',
  components: {
    'pt-link-manage': PtLinkManage
  },
  computed: {
    table () {
      return this.$refs.table.table
    }
  },
  methods: {
    deleteLink (id) {
      this.$store.dispatch('deleteLink', id).then(res => {
        this.$message.success('删除链接成功')
        this.table.getTableData(0)
      }).catch(err => {
        this.$message.error(err || '删除链接失败')
      })
    }
  }
}
</script>
